import { useOutsideClick } from '../../../util/misc';

interface Option {
    value: string;
    name: string;
}

interface SelectProps {
    name: string;
    value: string;
    options: Option[];
    onChange: (v: string | null) => void;
}

export default function Select({ name, value, options, onChange }: SelectProps) {
    const { isOpen, setIsOpen, dropdownRef } = useOutsideClick();
    return (
        <div
            className="shops__accordion-item menu-accordion"
            ref={dropdownRef}
            onClick={() => setIsOpen(!isOpen)}
        >
            <button
                className={
                    `menu-accordion__btn
                    menu-accordion__btn--state
                    menu-accordion__btn--shops` +
                    (isOpen ? ' menu-accordion__btn--indents  menu-accordion__btn--down' : '') +
                    (value ? ' menu-accordion__btn-open' : '')
                }
                type="button"
            >
                {value || name}
            </button>
            <ul className={'shops__filters-list' + (isOpen ? '' : ' menu-accordion__content--hide')}>
                <li className="shops__filters-item">
                    <button className="btn" type="button" onClick={() => onChange(null)}>
                        Все
                    </button>
                </li>
                {options.map((o) => (
                    <li key={o.value} className="shops__filters-item">
                        <button className="btn" type="button" onClick={() => onChange(o.value)}>
                            {o.name}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
